import axios from '@/plugins/axios'
import { Module } from 'vuex'

const tagGroupModule: Module<any, any> = {
    actions: {
        async getTagGroups(_, params) {

                const page = params?.page ? '&page=' + params.page : ''
                const perPage = params?.perPage
                    ? '&itemPerPage=' + params.perPage
                    : ''

                const response = await axios.get('/api/tag_groups?' + page + perPage)

                const records = {
                    items: response.data['hydra:member'],
                    count: response.data['hydra:totalItems'],
                }

            return records
        },
        async createTagGroups(_, params) {

            const response = await axios.post('/api/tag_groups' , {
                name:params.name 
            })

        return response
    },
    async EditTagGroups(_, params) {

        const response = await axios.put(`/api/tag_groups/${params.slug}/rename` , {
            name:params.name ,
            slug:params.slug
        })

    return response
},
    async deleteGroup(_,params) {
        let data 
        await  axios.delete(`/api/tag_groups/${params.slug}`).then((response)=>{
            data = response.data
        })
        return data
    },
    }
}


export default tagGroupModule